<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalLabel">Trip Cancel Reason</h5>
      <button
        ref="modalCloseBtn"
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
      >
        <i class="bi bi-x-circle"></i>
      </button>
    </div>
    <div class="modal-body">
      <div class="partner-modal-section">
        <div class="partner-modal-info">
          <div class="info-content fixed-height-info">
            <div class="info-row">
              <h5 class="item-heading">
                {{ driver?.trip_cancel_reason?.reason }}
              </h5>
              <h5 class="item-title">
                <b>Remarks:</b> {{ driver?.trip_cancel_reason?.remark }}
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['driver']
};
</script>

<style scoped>
.partner-modal-info .info-row {
  padding: 12px 0;
}
</style>
